export default __webpack_public_path__ + "static/media/booster-arrow.c569f878.svg";